<template>
  <NavBarWeb />
  <div style="text-align: left">
    <div class="sectionKoko">
      <div class="container">
        <div class="row mt-5">
          <div class="sectionHead">
            {{ cattype }}
          </div>
        </div>
        <div class="row mt-1">

          <div
            v-for="(item, $index) in list"
            :key="$index"
            class="post-item col-lg-3 col-md-4 col-sm-6 "
          >
            <!-- <h5>sample</h5> -->
            <div class="text-center mt-1">
              <a :href="item.siteUrl">
                <div style="">
                  &nbsp;
                  <!--        <div v-if="merchantData.doesOffline" class="text-right" style="background:#F3D0E4; margin-top:140px; margin-left:50%; margin-right: 5%;  height: 20px; font-size: 12px; font-weight: bolder;" >-->
                  <!--          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">-->
                  <!--            <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>-->
                  <!--          </svg> IN STORE-->
                  <!--        </div>-->
                  <img
                    :src="item.rectBannerUrl"
                    style="height:auto; width:100%;"
                    alt=""
                  />
             
                </div>
                {{ item.merchantName }}
               
              </a>
            </div>
    
          </div>
        </div>
      </div>
    </div>
  </div>

  <FooterWeb />
</template>

<script>
import NavBarWeb from "../components/NavBarWeb";
import FooterWeb from "../components/FooterWeb";
import { ref } from "vue";
import axios from "axios";

// Interop vue 2 component to vue 3
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";


toVue3.register(Vue2, Vue3);

const api = "https://devapi.paykoko.com/backend/merchantcat";

export default {
  name: "CategoryView",
  components: {
    FooterWeb,
    NavBarWeb
  },
  data() {
    return {
      finalId: 0,
      cattype:
        this.$route.query.cattype.charAt(0).toUpperCase() +
        this.$route.query.cattype.slice(1),
    };
  },
  setup() {
    const page = ref(1);
    const list = ref([]);
    let dataId = 0;
    // let docArray = new Map([])

    const infiniteHandler = async ($state) => {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      const { data } = await axios.post(
        api,
        '{"Page": ' +
          dataId +
          ',"CategoryName":"' +
          params.get("cattype") +
          '"}'
      );
      // console.log(docArray[0].merchantName)
      // " + +
      // console.log(this.data().finalId)
      // let test=JSON.parse(list.value);
      // console.log("Woah"+test)
      // console.log(test)
      // console.log(data)
      // list.value.values().

      if (data) {
        page.value += 1;
        list.value.push(...data);
        dataId = data[data.length - 1].id;
        $state.loaded();
      } else {
        console.log("End of the line");
        $state.complete();
      }
    };

    return {
      infiniteHandler,
      slots: {
        noMore: "Test",
      },
      list,
    };
  },
};
</script>

<style scoped>

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding: 5%;
}

.stepperHead {
  font-size: 50px;
  font-weight: bolder;
}

</style>
